import {type DataTypeProvider} from '@devexpress/dx-react-grid';

import {FormatDate} from '../../../../services/dateService';

export function OptixTableDataTypeDateFormatter({
  value,
}: DataTypeProvider.ValueFormatterProps): JSX.Element {
  return <>{FormatDate(value, 'date')}</>;
}
